import { CreditCard } from "lucide-react";
import type { ModuleSpec } from "../types";

export const billingSpec: ModuleSpec = {
  id: "billing",
  icon: CreditCard,
  i18n: {
    namespace: "modules",
    titleKey: "billing.title",
    descriptionKey: "billing.description",
  },
  nav: {
    path: "/account/billing",
    group: "account",
    order: 30,
  },
  permission: {
    action: "read",
    subject: "billing",
  },
  meta: {
    status: "active",
    description: "Manage billing and subscriptions",
  },
};
